<template>
  <div class="pa-4">
    <summary-pill-bar :pills="groupPills" :clickable="false" class="mb-3" />

    <v-row class="mb-2" dense>
      <v-col cols="12" sm="6" md="4">
        <text-field
          v-model="search"
          kind="search"
          clearable
          :placeholder="$t('contracts_search_placeholder')"
          hide-details
        />
      </v-col>
    </v-row>

    <!-- Desktop table -->
    <v-data-table
      v-if="!device.isMobile"
      :headers="headers"
      :items="filteredItems"
      :loading="loading"
      :loading-text="$t('loading_data')"
      sort-by="naziv"
      class="striped-table ordera-box-shadow"
      mobile-breakpoint="0"
    >
      <template v-slot:item.naziv="{ item }">
        <span class="font-weight-medium">{{ toLatin(item.naziv) }}</span>
      </template>

      <template v-slot:item.status="{ item }">
        <v-chip small color="warning" text-color="white">{{ item.status }}</v-chip>
      </template>

      <template v-slot:item.details="{ item }">
        <span v-if="item.nacin_naplate || item.iznos || item.vazi_od" class="caption grey--text">
          {{ item.nacin_naplate }}
          <template v-if="item.iznos">· {{ item.iznos }}</template>
          <template v-if="item.vazi_od">
            · {{ $t("price_valid_from") }} {{ localeDate(item.vazi_od) }}</template
          >
        </span>
        <span v-else class="grey--text">—</span>
      </template>

      <template v-slot:item.actions="{ item }">
        <div class="text-end">
          <v-btn small outlined color="primary" @click="$emit('open-item', item)">
            {{ $t("open") }}
          </v-btn>
        </div>
      </template>

      <template v-slot:no-data>
        <empty-state icon="mdi-cash-check" :title="$t('nothing_pending')" />
      </template>
    </v-data-table>

    <!-- Mobile cards -->
    <mobile-data-cards
      v-else
      :headers="mobileHeaders"
      :items="filteredItems"
      :loading="loading"
      item-key="restaurant_id"
      :show-row-number="false"
      :fields-per-row="2"
      :bold-fields="['naziv']"
      empty-icon="mdi-cash-check"
      :empty-title="$t('nothing_pending')"
    >
      <template v-slot:item.naziv="{ item }">{{ toLatin(item.naziv) }}</template>
      <template v-slot:item.status="{ item }">
        <v-chip x-small color="warning" text-color="white">{{ item.status }}</v-chip>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-btn small block outlined color="primary" @click="$emit('open-item', item)">
          {{ $t("open") }}
        </v-btn>
      </template>
    </mobile-data-cards>
  </div>
</template>

<script>
import SummaryPillBar from "./SummaryPillBar.vue";
import EmptyState from "@/components/global/EmptyState.vue";
import MobileDataCards from "@/components/global/MobileDataCards.vue";

export default {
  name: "PendingVerificationTab",
  components: { SummaryPillBar, EmptyState, MobileDataCards },
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    items: {
      type: Array,
      default: () => [],
    },
    groups: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      search: "",
    };
  },
  computed: {
    headers() {
      return [
        { text: this.$t("restaurant"), value: "naziv", sortable: true },
        { text: this.$t("status"), value: "status", sortable: true, width: "220px" },
        { text: this.$t("details"), value: "details", sortable: false },
        { text: this.$t("actions"), value: "actions", sortable: false, align: "end" },
      ];
    },
    mobileHeaders() {
      return [
        { text: this.$t("restaurant"), value: "naziv", cols: 12 },
        { text: this.$t("status"), value: "status", cols: 12 },
        { text: "", value: "actions", cols: 12 },
      ];
    },
    groupPills() {
      return Object.entries(this.groups).map(([group, count]) => ({
        key: group,
        label: group,
        count,
        color: "#fb8c00",
      }));
    },
    filteredItems() {
      return this.customSearch(this.items, [{ value: "naziv" }, { value: "status" }], this.search);
    },
  },
};
</script>
